export default "__VITE_ASSET__BI0rvDsz__"